import { RootState } from '@reducers/index';

export const getMenuOpen = (state: RootState): boolean | null =>
    state.mobileSettingsReducer.menuOpen;
